import './styles/Token.scss';
import pbxToken from '../svg/pbx-token.png';
import powerImage from '../svg/power_image.png';

function Token() {


    return (
      
    <main>
      <section className="token" id="paribus">
          <div className="tokenContainer">
            <div className="secondPart" id="pbkToken">
              <div className="textPart">
                <div className="leftPart">
                  <img
                    src={pbxToken}
                    alt=""
                    className="power-image-left"
                  />
                </div>
                <div className="rightPart">
                  <h2 className="titleH2 firstTitle">
                    The <span>PBX</span> Token
                  </h2>
                  <p className="desc1 firstText">
                    PBX is Paribus’ native governance token, allowing holders to
                    create and vote on proposals relating to protocol guidance.
                    The PBX token’s ultimate goal is to align the incentives
                    across the Paribus yield protocol, creating a codified
                    harmony between stakeholders, the protocol itself, and the
                    security of the assets contained within it.
                  </p>
                </div>
                <p className="subtitle colorGradientBlue">
                  PBX token holders are also entitled to a percentage of fees
                  earned by the protocol, relative to their stake. The bigger
                  the stake, the greater the tier, and the larger the percentage
                  earned.
                </p>
              </div>
              <img
                src={powerImage}
                alt=""
                className="powerImageBottomRight"
              />
            </div>
          </div>
        </section>
     
    </main>
       
    )
}

export default Token;